import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary'
import { ThemeProvider } from './contexts/ThemeContext'
import { ToastProvider } from './components/UI/Toast'
import SEOHead from './components/SEO/SEOHead'
import './App.css'

// Lazy loading dos componentes com preload hints
const Home = lazy(() => 
  import(/* webpackChunkName: "home" */ './components/Home/Home')
)
const VoucherPage = lazy(() => 
  import(/* webpackChunkName: "voucher" */ './components/Voucher/VoucherPage')
)
const TotemPage = lazy(() => 
  import(/* webpackChunkName: "totem" */ './components/Totem/TotemPage')
)
const AdminPage = lazy(() => 
  import(/* webpackChunkName: "admin" */ './components/Admin/AdminPage')
)

// Optimized Loading component
const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
    <div className="text-center">
      <div className="inline-flex items-center justify-center w-16 h-16 bg-primary rounded-full mb-4 animate-pulse">
        <span className="material-symbols-outlined text-white text-3xl">hourglass_empty</span>
      </div>
      <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">Carregando...</h3>
      <p className="text-gray-600 dark:text-gray-400">Preparando sua experiência</p>
    </div>
  </div>
)

function App() {
  return (
    <ThemeProvider>
      <ToastProvider>
        <ErrorBoundary>
          <SEOHead />
          <Router>
            <div className="min-h-screen" id="app-scroll-container">
              <Suspense fallback={<PageLoader />}>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/voucher/:voucherId" element={<VoucherPage />} />
                  <Route path="/totem" element={<TotemPage />} />
                  <Route path="/admin" element={<AdminPage />} />
                </Routes>
              </Suspense>
            </div>
          </Router>
        </ErrorBoundary>
      </ToastProvider>
    </ThemeProvider>
  )
}

export default App
